var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"table-container",class:_vm.classes,on:{"scroll":_vm.handleScroll}},[_c('table',{staticClass:"table"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }